module.exports = __webpack_public_path__ + "static/media/myrmeleotettix_maculatus_002_APA.a04329f1.mp3";